import { InjectionKey, ref } from "vue";
export type IVideoViewType = "doc" | "video";
export const VideoToolsServiceKey: InjectionKey<VideoToolsService> = Symbol();
export class VideoToolsService {
  public changeViewRef = ref<IVideoViewType>("video");
  public fullscreenRef = ref(false);
}
